import { render, staticRenderFns } from "./commonPhrases.vue?vue&type=template&id=a14b52cc&scoped=true"
import script from "./commonPhrases.vue?vue&type=script&lang=js"
export * from "./commonPhrases.vue?vue&type=script&lang=js"
import style0 from "./commonPhrases.vue?vue&type=style&index=0&id=a14b52cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14b52cc",
  null
  
)

export default component.exports